import { combineReducers } from 'redux';

import documentExtension from './documentExtension';
import documentUploadStatus from './documentUploadStatus';
import isRejecting from './isRejecting';

export default combineReducers({
  documentExtension,
  documentUploadStatus,
  isRejecting,
});
